import React, { useEffect, useState } from 'react';
import Universalpageheader from '../Headers/universalpageheader';
import Productcard from '../Products/productcard';
import { Button, CircularProgress } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import Searchbar from '../Components/searchbar';
import Countdown from 'react-countdown';
import fetch from '../Utils/fetch';
import { Productcardskeleton } from '../Components/skeletons';


function Flashsales() {
    const dispatch = useDispatch();
    const subProducts = useSelector((state) => state.subProducts.data);
    const locationData = useSelector((state) => state.location.data);

    const [loading, setloading] = useState(false);
    const [showsearchbar, setshowsearchbar] = useState(false);

    const [topSellingProducts, settopSellingProducts] = useState([]);

    const now = new Date();
    const midnight = new Date(now);
    midnight.setHours(24, 0, 0, 0); // Set to 00:00:00 of the current day
    const diff = midnight - now;

    useEffect(() => {
        loadtopselling()
        window.scrollTo(0, 0);
    }, [locationData?.mainLocation]);


    //fetch top selling products
    function loadtopselling() {
        setloading(true)
        fetch
            .get('getTodaysDeals', { location: locationData?.mainLocation })
            .then((res) => {
                if (res.list.length > 0) {
                    setloading(false)
                    settopSellingProducts(res.list)
                } else {
                    fetch
                        .get('getTopSellingProducts', { location: locationData?.mainLocation })
                        .then((res) => {
                            setloading(false)
                            settopSellingProducts(res.list)
                        })
                }
            })
    }


    // Renderer callback with condition
    const renderer = ({ hours, minutes, seconds, completed }) => {
        if (completed) {
            // Render a completed state
            return <Completionist />;
        } else {
            // Render a countdown
            return <span> {hours}h :{minutes}m :{seconds}s</span>;
        }
    };



    return (
        <div className="homebody">
            {showsearchbar && <Searchbar dismissmodals={() => setshowsearchbar(false)} products={subProducts?.flatMap((obj) => obj.items)} />}
            <Universalpageheader onshowsearch={() => setshowsearchbar(true)} pagename={"Flash sales"} withbackicon={true} />
            <section className="flashsalepageheader">
                <div style={{ display: "flex", fontSize: 15, justifyContent: "center", alignItems: "center" }}>
                    TIME LEFT: &nbsp;
                    <div style={{ fontWeight: "bold", fontSize: 14 }}>
                        <Countdown
                            date={Date.now() + diff}
                            renderer={renderer}
                        />
                    </div>
                </div>
            </section>
            <div>
                <div className='wrapfourcards' style={{ height: "80%" }}>
                    {topSellingProducts.length > 0 ? topSellingProducts?.map((val, key) => {
                        return (
                            <Productcard showrating={true} product={val} key={key} showoffer={true} showquantity={true} />
                        )
                    }) :
                        Array.from({ length: 20 }, (_, index) => (
                            <Productcardskeleton key={index} />
                        ))}
                </div>
            </div>
        </div>
    );
}




export default Flashsales;
